module.exports = __webpack_public_path__ + "img/obtawhicon1.e05d550f.png";